<template>
  <div class="robot-move">
    <Card :bordered="false">
      <div slot="title">
        <Row>
          <Col :xs="24" :sm="24" :md="12" :lg="16">
            <Divider orientation="left">{{langMap.robotMoveManagement[lang]}}</Divider>
          </Col>
          <!-- Add search form -->
          <Col :xs="24" :sm="24" :md="12" :lg="8">
            <Form :label-width="80">
              <div class="des-cardTittle-box">
                <FormItem :label="langMap.serialNumber[lang]" class="leftFlex">
                  <Input v-model.trim="code" :placeholder="langMap.serialNumber[lang]" clearable />
                </FormItem>
                <Button type="info" style="margin-left:20px;" @click="searchData">{{langMap.search[lang]}}</Button>
              </div>
            </Form>
          </Col>
        </Row>
      </div>

      <Table :height="height" :loading="tableLoading" border :columns="robotColumns" :data="robotList"></Table>
      
      <div style="text-align:center;padding-top:10px;" v-if="robotList.length>0">
        <Page :current="index" :total="total" :page-size="15" @on-change="goPageData"></Page>
      </div>
    </Card>

    <!-- 迁移租户模态框 -->
    <Modal v-model="moveModal" :title="langMap.moveTenant[lang]" width="500">
      <Form :label-width="80">
        <FormItem :label="langMap.targetTenant[lang]">
          <Select v-model="targetTenantId">
            <Option v-for="item in tenantList" :value="item.id" :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="moveModal = false">{{langMap.cancel[lang]}}</Button>
        <Button type="primary" :loading="moveLoading" @click="handleMove">{{langMap.confirm[lang]}}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import api from "@/api"
import langMap from '@/utils/language'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      langMap: langMap,
      height: document.documentElement.clientHeight - 300,
      tableLoading: false,
      moveLoading: false,

      // 列表数据
      index: 1,
      total: 0,
      robotList: [],
      tenantList: [],
      
      // 迁移相关
      moveModal: false,
      targetTenantId: '',
      selectedRobot: null,

      // 租户名称映射
      tenantMap: {},

      // Add search field
      code: '',
    }
  },

  computed: {
    ...mapState({
      lang: state => state.app.language
    }),

    robotColumns() {
      return [
        {
          title: '#',
          width: 80,
          key: 'index',
          render: (h, params) => {
            return h('span', params.index + 1)
          }
        },
        {
          title: this.langMap.productId[this.lang],
          width: 120,
          key: 'productId'
        },
        {
          title: this.langMap.serialNumber[this.lang],
          width: 120,
          key: 'code'
        },
        {
          title: this.langMap.name[this.lang],
          width: 120,
          key: 'name'
        },
        {
          title: this.langMap.tenantCode[this.lang],
          width: 120,
          key: 'tenantId'
        },
        {
          title: this.langMap.tenantName[this.lang],
          width: 120,
          key: 'tenantId',
          render: (h, params) => {
            return h('span', this.tenantMap[params.row.tenantId] || '')
          }
        },
        {
          title: this.langMap.operation[this.lang],
          width: 150,
          render: (h, params) => {
            return h('Button', {
              props: {
                type: 'primary',
                size: 'small'
              },
              on: {
                click: () => {
                  this.selectedRobot = params.row
                  this.moveModal = true
                }
              }
            }, this.langMap.moveTenant[this.lang])
          }
        }
      ]
    }
  },

  methods: {
    // 获取租户列表
    getTenantList() {
      api.getData('system-server/tenant/list', this).then(res => {
        if (res.state === 0) {
          this.$Notice.error({
            title: this.langMap.tip[this.lang],
            desc: res.msg
          })
        } else {
          this.tenantList = res.data
          // 构建租户名称映射
          this.tenantList.forEach(tenant => {
            this.tenantMap[tenant.id] = tenant.name
          })
          this.getRobotList()
        }
      })
    },

    // 获取机器人列表
    getRobotList() {
      this.tableLoading = true
      api.getData(`robot-server/robot/allTenantRobotList?code=${this.code || ''}&index=${this.index}`, this).then(res => {
        if (res.state === 0) {
          this.$Notice.error({
            title: this.langMap.tip[this.lang],
            desc: res.msg
          })
        } else {
          this.robotList = res.data.rows
          this.total = res.data.total
        }
        this.tableLoading = false
      })
    },

    // 执行迁移
    handleMove() {
      if (!this.targetTenantId) {
        this.$Notice.warning({
          title: this.langMap.tip[this.lang],
          desc: this.langMap.selectTargetTenant[this.lang]
        })
        return
      }

      this.moveLoading = true
      api.postData('robot-server/robot/moveRobot', {
        robotId: this.selectedRobot.id,
        targetTenantId: this.targetTenantId
      }, this).then(res => {
        if (res.state === 0) {
          this.$Notice.error({
            title: this.langMap.tip[this.lang],
            desc: res.msg
          })
        } else {
          this.$Notice.success({
            title: this.langMap.tip[this.lang],
            desc: this.langMap.success[this.lang]
          })
          this.moveModal = false
          this.getRobotList()
        }
        this.moveLoading = false
      })
    },

    // 分页
    goPageData(index) {
      this.index = index
      this.getRobotList()
    },

    // Add search method
    searchData() {
      this.index = 1
      this.getRobotList()
    }
  },

  created() {
    this.getTenantList()
  }
}
</script>

<style lang="less">
.robot-move {
  .des-cardTittle-box {
    display: flex;
    align-items: center;
  }
  .leftFlex {
    margin-right: 10px;
  }
}
</style>
